import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { AuthService } from '../auth/auth.service';
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private APIUrl: string;
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,
        private _authenticationService: AuthService
    )
    {
        this.APIUrl = environment.apiUrl;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        //Call new API to get navigation data
        return this._httpClient.get<Navigation>(`${this.APIUrl}users/menu`).pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
            }),
            catchError((err) => {
                if(err.status === 401){
                    this._authenticationService.signOut();
                    this._navigation.next(null);
                    return of(null);
                }
                this._navigation.next(null);
                return of(null);
            })
        );
    }
}
